export default __webpack_public_path__ + "static/media/header_edge_yellow.e5aa5c2f.png";